import styled from 'styled-components';

import Toggle from '#/components/common/Toggle';
import Tooltip, { HelpUnderline } from '#/components/shared/Tooltip';

import { useAuthActions, useAuthView } from '#/features/auth/auth-context';
import { useWalletView } from '#/features/wallet/wallet-context';
import { useTranslation } from '#/features/localization/utils';

export default function RememberMe() {
  const authView = useAuthView();
  const authActions = useAuthActions();
  const walletView = useWalletView();
  const { t } = useTranslation();

  return (
    <Tooltip
      label={t(
        'Only use “Remember Me” if you are using a secure device you own. Selecting this option can expose your information to  others if you are accessing this wallet from a public device.',
      )}
    >
      <Label>
        <Toggle
          disabled={walletView.status !== 'idle'}
          checked={authView.rememberMe}
          onChange={(event) => authActions.setRememberMe(event.target.checked)}
        />
        <LabelText as={HelpUnderline}>{t('Remember Me')}</LabelText>
      </Label>
    </Tooltip>
  );
}

const Label = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

const LabelText = styled.span`
  opacity: 0.7;
  font-size: 12px;
  font-weight: 500;
`;
